(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/header-portal/header-portal.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/header-portal/header-portal.js');
"use strict";


const _ReactDOM = ReactDOM,
  createPortal = _ReactDOM.createPortal;
const _React = React,
  useContext = _React.useContext;
const User = svs.ticket_partner.sharedComponents.headerPortal.components.User;
const HeaderPortal = () => {
  const portalEl = document.querySelector('#login-portal');
  const _useContext = useContext(svs.ticket_partner.UserContext),
    isLoggedIn = _useContext.isLoggedIn;
  if (portalEl && isLoggedIn) {
    return createPortal(React.createElement(User, null), portalEl);
  }
  return null;
};
svs.ticket_partner.sharedComponents.headerPortal.HeaderPortal = HeaderPortal;

 })(window);